import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from 'modules/Taps/constants';

/**
 *
 * @param cardId
 * @param type - documents type incoming/outgoing
 * @returns {AxiosPromise}
 */
export default function getDeclarationDocuments(cardId, type = 'incoming') {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/${cardId}/documents/${type}`,
  });
}
